<template>
  <div class="paintings">
    <navigation></navigation>
    <!-- Circle Preloader -->
    <h3 class="headlink">
      Video
    </h3>
    <p class="text-center">Shortfilms and trailers i've worked on.</p>

    <div class="container">
      <div class="card-columns">
        <div class="card border-0 p-2">
          <youtube
            video-id="HcojdLlum6s"
            ref="youtube"
            height="200px"
            resize="true"
            @playing="playing"
          ></youtube>
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Shortfilms for Dogs Bones and Catering</strong><br />
              Shortfilm submissions for the shortfilmfestival
              <u
                ><a href="https://www.dogsbonesandcatering.de/" target="new"
                  >Dogs Bones and Catering</a
                ></u
              >
              in Dresden, where you have to make a shortmovie in 40h.<br /><br />

              <a href="https://www.youtube.com/watch?v=HcojdLlum6s" target="new"
                ><i class="fa fa-youtube"></i> Time Over (2017)<br
              /></a>
              <a href="https://www.youtube.com/watch?v=TeRvW3q2afk" target="new"
                ><i class="fa fa-youtube"></i> Chamaoleon (2016)<br
              /></a>
              <a href="https://www.youtube.com/watch?v=2fQ8WaX9RL4" target="new"
                ><i class="fa fa-youtube"></i> Da ist noch was (2014)<br
              /></a>
              <a href="https://www.youtube.com/watch?v=WaS9_CiBzrA" target="new"
                ><i class="fa fa-youtube"></i> Der Dilettant (2012)<br
              /></a>
              <a href="https://www.youtube.com/watch?v=P1efn1OiRRY" target="new"
                ><i class="fa fa-youtube"></i> Das letzte Hemd (2011)<br
              /></a>
            </p>
          </div>
        </div>
        <div class="card border-0 p-2">
          <youtube
            video-id="Bs_ObjeFpvA"
            ref="youtube"
            height="200px"
            resize="true"
            @playing="playing"
          ></youtube>
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>The Borner Skate Archives</strong><br />
              A skateboardingvideo capturing my skateboardingcareer from
              1999-2002 as a kid.<br /><br />
              <a href="https://www.youtube.com/watch?v=Bs_ObjeFpvA" target="new"
                ><i class="fa fa-youtube"></i> watch on youtube<br
              /></a>
            </p>
          </div>
        </div>
        <div class="card border-0 p-2">
          <youtube
            video-id="KvgcpToI-UQ"
            ref="youtube"
            height="200px"
            resize="true"
            @playing="playing"
          ></youtube>
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Artperformances</strong><br />
              Performances I did with Holger John, the Kessler Schwarz Group and
              others.<br /><br />

              <a
                href="https://www.youtube.com/watch?v=KvgcpToI-UQ"
                target="new"
              >
                <i class="fa fa-youtube"></i> Putin Love (2009)</a
              ><br />
              <a
                href="https://www.youtube.com/watch?v=lyWhS2pD_20"
                target="new"
              >
                <i class="fa fa-youtube"></i> KS- Mask (2012)</a
              >
              <br />
              <a
                href="https://www.youtube.com/watch?v=MYcSzepTuQ8"
                target="new"
              >
                <i class="fa fa-youtube"></i> KS - Red Splash (2013)</a
              >
              <br />
              <a
                href="https://www.youtube.com/watch?v=trxPyajpTHg"
                target="new"
              >
                <i class="fa fa-youtube"></i> KS - Fire (2012)</a
              >
              <br />
              <a
                href="https://www.youtube.com/watch?v=Y9ahFcOOQQI"
                target="new"
              >
                <i class="fa fa-youtube"></i> Lippitt Light Experiments
                (2008)</a
              >
            </p>
          </div>
        </div>
      </div>
      <!-- end row 1 -->
      <div class="card-columns">
        <div class="card border-0 p-2">
          <youtube
            video-id="bDjZW2ae6hE"
            ref="youtube"
            height="200px"
            resize="true"
            @playing="playing"
          ></youtube>
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Trailers for Holger John</strong><br />
              Trailers I made for events and parties from Holger John.<br /><br />

              <a
                href="https://www.youtube.com/watch?v=bDjZW2ae6hE"
                target="new"
              >
                <i class="fa fa-youtube"></i> Filmball - Dirty Dancing (2010)</a
              ><br />
              <a
                href="https://www.youtube.com/watch?v=evhexbiw3f0"
                target="new"
              >
                <i class="fa fa-youtube"></i> Renovatum HfBK Party (2009)</a
              ><br />
              <a
                href="https://www.youtube.com/watch?v=mvafxO6H52Y"
                target="new"
              >
                <i class="fa fa-youtube"></i> Filmball - Nacht der Vampire
                (2009)</a
              >
            </p>
          </div>
        </div>
        <div class="card border-0 p-2">
          <youtube
            video-id="kWWrqMqKp6c"
            ref="youtube"
            height="200px"
            resize="true"
            @playing="playing"
          ></youtube>
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Musicvideos</strong><br />
              several Musicvideos I made for different music projects .<br /><br />

              <a
                href="https://www.youtube.com/watch?v=kWWrqMqKp6c"
                target="new"
              >
                <i class="fa fa-youtube"></i> VISION30 - Whyro feat. Anne
                (2013)</a
              ><br />
              <a href="https://www.youtube.com/watch?v=iheoxKz_hkk" target="new"
                ><i class="fa fa-youtube"></i> Oliver Decrow - I can't breathe
                (2020)<br
              /></a>
              <a href="https://www.youtube.com/watch?v=_Mu8sJEgpDo" target="new"
                ><i class="fa fa-youtube"></i> Oliver Decrow - Black Spring
                (2019)<br
              /></a>
              <a href="https://www.youtube.com/watch?v=lLUMeNq7NLA" target="new"
                ><i class="fa fa-youtube"></i> WHY NOT Disko (2014)<br
              /></a>
              <a
                href="https://www.youtube.com/playlist?list=PL31AFE2E542F5340D"
                target="new"
                ><i class="fa fa-youtube"></i> Elli.Olli Musicvideos, Playlist
                (2012)<br
              /></a>
              <a href="https://www.youtube.com/watch?v=phgTx8Ekd1U" target="new"
                ><i class="fa fa-youtube"></i> Colt Cody - Mickey Mouse
                (2014)<br
              /></a>
            </p>
          </div>
        </div>
        <div class="card border-0 p-2">
          <youtube
            video-id="zOBNF2wkZs8"
            ref="youtube"
            height="200px"
            resize="true"
            @playing="playing"
          ></youtube>
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Fashion videos</strong><br />
              Videos I made for Bornutti.<br /><br />

              <a
                href="https://www.youtube.com/watch?v=zOBNF2wkZs8"
                target="new"
              >
                <i class="fa fa-youtube"></i> The Bornutti Bag (2016)</a
              ><br />
              <a
                href="https://www.youtube.com/watch?v=jfBgcqe-HeY"
                target="new"
              >
                <i class="fa fa-youtube"></i> Ghette di Ghetto (2016)</a
              >
            </p>
          </div>
        </div>
      </div>
      <!-- end row 2 -->
    </div>

    <!--container end div-->
    <back-to-top bottom="20px" right="20px">
      <button type="button" class="btn btn-light btn-to-top">
        <i class="fa fa-chevron-up"></i>
      </button>
    </back-to-top>
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";

export default {
  components: {
    navigation,
  },
  data() {
    return {};
  },
  methods: {
    playVideo() {
      this.player.playVideo();
    },
    playing() {},
  },
  computed: {
    player() {
      return this.$refs.youtube.player;
    },
  },
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
iframe {
  background-color: transparent;
  width: 100%;
  border: 1px solid #c3c3c3;
}
</style>
